import React, { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../../../../../AppContext";
import "./LoginModal.css";
import closeSvg from "../../../../../assets/closeSvg";
import bcrypt from "bcryptjs-react";
import {
  logActivity,
  getUserId,
  getUserInfoWithId,
  sendTextNotification,
} from "../../../../utils";

const LoginModal = () => {
  const ref = useRef();

  const [temporaryResetCode, setTemporaryResetCode] = useState("");
  const [temporaryUserId, setTemporaryUserId] = useState("");
  const [temporaryUserEmail, setTemporaryUserEmail] = useState("");

  const {
    setUserId,
    setMatrixData,
    modal,
    setModal,
    loginModalInputs,
    setLoginModalInputs,
    loginModalAction,
    setLoginModalAction,
    userType,
    setUserName,
    setUserEmail,
    setUserPassword,
    setUserPhone,
    setTextNotifications,
    setPath,
    userCompany,
    setUserCompany,
    setUserCompanyId,
    makeKey,
    setMakeKey,
    movePassword,
    setNavbar,
    setMidbar,
    userName,
    navigate,
    setClientSelection,
    setFubId,
    setFubKey,
    setTeamMemberSelected,
    setTeamMemberSelectedInfo,
    setTeamPermissions,
    setBuyersGuide,
    setBuyersGuideEditable,
  } = useContext(AppContext);

  function resetPasswordTemporaryCode(userEmail) {
    setLoginModalInputs([
      [
        "checkingForEmail",
        "A 6 digit code is being sent to the email and phone associated with your account...",
        "none",
      ],
    ]);
    fetch("https://hook.us1.make.com/j3lsxl8dxqf9xjr7pcvecu543414cvqz", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        userEmail: userEmail,
        userType: userType,
        apiKey: makeKey,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        const dataTemporaryUserId = data[0]["userId"];
        setTemporaryUserId(dataTemporaryUserId);
        const dataTemporaryResetCode = data[0]["temporaryResetCode"];
        setTemporaryResetCode(dataTemporaryResetCode);
        const dataTemporaryPhone = data[0]["userPhone"];
        sendTextNotification({
          textNotificationsAllowed: true,
          textMessage: `Matrix App Reset Code:\n${dataTemporaryResetCode}`,
          textPhone: dataTemporaryPhone,
        });
        setTemporaryUserEmail(userEmail);
        setTimeout(() => {
          document.getElementById("LoginModalForm").reset();
          setLoginModalInputs([
            ["userTemporaryResetCode", "Temporary Reset Code:", "text"],
          ]);
          setLoginModalAction("checkTemporaryResetCode");
        }, 2000);
      })
      .catch((error) => {
        alert(
          "Invalid account :( \n\n> Reach out to mike@movemortgage.com to set up your account!"
        );
        document.getElementById("LoginModalForm").reset();
        setModal("inactive");
        logActivity({
          apiKey: makeKey,
          userEmail: userEmail,
          userType: userType,
          action: "Invalid Account Alert",
          tab: "Login",
          userCompany: userCompany,
        });
      });
  }

  function checkTemporaryResetCode(userTemporaryResetCode) {
    if (temporaryResetCode === userTemporaryResetCode) {
      setUserEmail(temporaryUserEmail);

      document.getElementById("LoginModalForm").reset();

      setLoginModalInputs([
        ["userNewPassword", "New Password:", "password"],
        ["userConfirmPassword", "Confirm Password:", "password"],
      ]);
      setLoginModalAction("resetPasswordWithId");
    } else {
      alert("Invalid reset code. Please try again.");
    }
  }

  function resetPasswordWithId(password) {
    bcrypt.hash(password, 10).then((hash) => {
      fetch("https://hook.us1.make.com/fh0ho7mgypago3flw29h0a6w19cdo0co", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          userType: userType,
          userId: temporaryUserId,
          password: hash,
          apiKey: makeKey,
          userEmail: temporaryUserEmail,
        }),
      }).then((response) => {
        document.getElementById("LoginModalForm").reset();
        setLoginModalAction("");
        setModal("inactive");
        getUserInfoWithId({
          userId: temporaryUserId,
          setUserId: setUserId,
          setTeamMemberSelectedInfo: setTeamMemberSelectedInfo,
          setMatrixData: setMatrixData,
          setUserName: setUserName,
          setUserPhone: setUserPhone,
          setTextNotifications: setTextNotifications,
          setUserCompany: setUserCompany,
          setUserCompanyId: setUserCompanyId,
          userCompany: userCompany,
          setLoginModalAction: setLoginModalAction,
          setModal: setModal,
          userType: userType,
          makeKey: makeKey,
          setPath: setPath,
          navigate: navigate,
          setClientSelection: setClientSelection,
          setFubId: setFubId,
          setFubKey: setFubKey,
          setTeamMemberSelected: setTeamMemberSelected,
          path: "/home",
          clientSelection: "Pending",
          setTeamPermissions: setTeamPermissions,
          action: "Reset Password",
          setBuyersGuideEditable: setBuyersGuideEditable,
        });
        setNavbar("nav-bar");
      });
    });
  }

  const runAction = ({
    userEmail,
    userTemporaryResetCode,
    userNewPassword,
    userPassword,
  }) => {
    switch (loginModalAction) {
      case "getUserId":
        getUserId({
          userEmail: userEmail,
          setUserId: setUserId,
          setTeamMemberSelectedInfo: setTeamMemberSelectedInfo,
          userType: userType,
          makeKey: makeKey,
          userPassword: userPassword,
          movePassword: movePassword,
          setUserPhone: setUserPhone,
          setTextNotifications: setTextNotifications,
          setLoginModalInputs: setLoginModalInputs,
          setMatrixData: setMatrixData,
          setLoginModalAction: setLoginModalAction,
          setModal: setModal,
          setNavbar: setNavbar,
          setMidbar: setMidbar,
          setUserEmail: setUserEmail,
          setUserCompany: setUserCompany,
          setUserCompanyId: setUserCompanyId,
          setUserPassword: setUserPassword,
          setUserName: setUserName,
          setMakeKey: setMakeKey,
          setPath: setPath,
          navigate: navigate,
          setClientSelection: setClientSelection,
          path: "/home",
          clientSelection: "Pending",
          setFubId: setFubId,
          setFubKey: setFubKey,
          action: "Login",
          actionTab: "Login",
          setTeamMemberSelected: setTeamMemberSelected,
          setTeamPermissions: setTeamPermissions,
          setBuyersGuide: setBuyersGuide,
          setBuyersGuideEditable: setBuyersGuideEditable,
        });
        break;
      case "resetPasswordTemporaryCode":
        resetPasswordTemporaryCode(userEmail);
        logActivity({
          apiKey: makeKey,
          userEmail: userEmail,
          userType: userType,
          action: "Reset Password",
          tab: "Login",
          userCompany: userCompany,
        });
        break;
      case "checkTemporaryResetCode":
        checkTemporaryResetCode(userTemporaryResetCode);
        break;
      case "resetPasswordWithId":
        resetPasswordWithId(userNewPassword);
        break;
      case "createAccount":
        resetPasswordTemporaryCode(userEmail);
        logActivity({
          apiKey: makeKey,
          userEmail: userEmail,
          userType: userType,
          action: "Create Account",
          tab: "Login",
          userCompany: userCompany,
        });
        break;
      default:
        break;
    }
  };

  const [passwordsMatch, setPasswordsMatch] = useState(
    <div className="doesNotMatch">must match</div>
  );
  const [passwordsMatchCheck, setPasswordsMatchCheck] = useState(Math.random());

  useEffect(() => {
    if (document.getElementById("userNewPassword")) {
      if (
        document.getElementById("userNewPassword").value ===
        document.getElementById("userConfirmPassword").value
      ) {
        setPasswordsMatch(<div className="matches">matches</div>);
      } else {
        setPasswordsMatch(<div className="doesNotMatch">must match</div>);
      }
    }
  }, [passwordsMatchCheck]);

  const inputs = () => {
    return loginModalInputs.map((e, index) => {
      return (
        <div className="LoginModalInput" key={index}>
          <div className="loginModalLabel">
            <label htmlFor={e[0]}>{e[1]}</label>
            {e[0] == "userConfirmPassword" ? passwordsMatch : null}
          </div>
          {e[2] !== "none" ? (
            <input
              className="loginInput"
              type={e[2]}
              id={e[0]}
              name={e[1]}
              autoComplete={
                e[0] == "userTemporaryResetCode"
                  ? "one-time-code"
                  : e[0] == "userNewPassword"
                  ? "new-password"
                  : ""
              }
              onChange={() => {
                setPasswordsMatchCheck(Math.random());
              }}
            ></input>
          ) : null}
        </div>
      );
    });
  };

  const checkPassword = () => {
    if (
      document.getElementById("userNewPassword").value !==
      document.getElementById("userConfirmPassword").value
    ) {
      return [
        false,
        '"New Password" and "Confirm Password" must match. Please try again.',
      ];
    } else if (document.getElementById("userNewPassword").value.length < 5) {
      return [
        false,
        "Password length is less than 5 characters. Please use a password with 5 or more characters.",
      ];
    } else {
      return [true];
    }
  };

  const submitButton = () => {
    if (loginModalInputs[0][2] !== "none") {
      return (
        <input
          type="submit"
          value="Submit"
          className="submit button"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            if (loginModalInputs[0][0] == "userNewPassword") {
              if (checkPassword()[0]) {
                runAction({
                  userNewPassword: document.getElementById("userNewPassword")
                    ? document.getElementById("userNewPassword").value
                    : "",
                });
              } else {
                alert(checkPassword()[1]);
              }
            } else {
              runAction({
                userEmail: document.getElementById("userEmail")
                  ? document.getElementById("userEmail").value
                  : "",
                userTemporaryResetCode: document.getElementById(
                  "userTemporaryResetCode"
                )
                  ? document.getElementById("userTemporaryResetCode").value
                  : "",
                userPassword: document.getElementById("userPassword")
                  ? document.getElementById("userPassword").value
                  : "",
              });
            }
          }}
        ></input>
      );
    }
  };

  return (
    <div className={`LoginModalPage ${modal}`}>
      <div className={`LoginModal-background`}></div>
      <form className={`LoginModal`} id="LoginModalForm" ref={ref}>
        {loginModalInputs[0][0] == "loadingData" ||
        loginModalInputs[0][0] == "checkingForEmail" ||
        loginModalInputs[0][0] == "userTemporaryResetCode" ||
        loginModalInputs[0][0] == "userNewPassword" ? null : (
          <div
            className="LoginModal-close"
            onClick={() => {
              setModal("inactive");
            }}
          >
            {closeSvg}
          </div>
        )}
        {inputs()}
        {submitButton()}
      </form>
    </div>
  );
};

export default LoginModal;
